import { makeStyles } from '@soil-capital/ui-kit/style';

export const useConfirmDeleteAllOperationsModalStyles = makeStyles()((theme) => ({
    redButton: {
        backgroundColor: theme.palette.error.main,
    },
}));
